import type { IconSvgObject } from './types';

const SearchXIcon: IconSvgObject = [
  ["path", { d: "M16.9922 17L20.9922 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.9922 11C18.9922 6.58172 15.4105 3 10.9922 3C6.57391 3 2.99219 6.58172 2.99219 11C2.99219 15.4183 6.57391 19 10.9922 19C15.4105 19 18.9922 15.4183 18.9922 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.99219 8L10.9922 11M10.9922 11L13.9922 14M10.9922 11L13.9922 8M10.9922 11L7.99219 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SearchXIcon;
